import { PlatformLocation } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatDialogRef, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Filtro } from 'src/app/models/filtro';
import { Funcionario } from 'src/app/models/funcionario';
import { CRM } from '../../models/crm/crmfunil';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PaginatorService } from 'src/app/services/paginator.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { CrmService } from 'src/app/services/crm/crm.service';
import { FVFunilService } from 'src/app/services/fvfunil.service';

@Component({
  selector: 'app-funcionarios-modal',
  templateUrl: './funcionarios-modal.component.html',
  styleUrls: ['./funcionarios-modal.component.scss']
})
export class FuncionariosModalComponent implements OnInit {

  funcionariosFiltrados: Funcionario[] = [];

  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;

  nomeSistema = '';

  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  mostrarBotoes = true;
  mostrarFunil = false;
  funis: CRM[];

  // variáveis seleção por checkbox
  trabalharComCheckBox = false;
  selecaoTodos = false;
  semFiltroFranquia = false;

  mostrarSomenteDoFunil = false;

  public config: PerfectScrollbarConfigInterface = {};

  funcionariosJaSelecionados = [];

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(public dialogRef: MatDialogRef<FuncionariosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private funcionarioService: FuncionarioService,
    private notificacaoService: NotificacaoService, private carregandoService: CarregandoService,
    private funilService: FVFunilService, private paginatorService: PaginatorService, private crmService: CrmService) {

    if (data && data.trabalharComCheckBox !== undefined) {
      this.trabalharComCheckBox = data.trabalharComCheckBox;
      this.mostrarBotoes = !this.trabalharComCheckBox;
    }

    if (data && data.mostrarBotoes !== undefined) {
      this.mostrarBotoes = data.mostrarBotoes;
    }

    if (data && data.funcionariosJaSelecionados) {
      this.funcionariosJaSelecionados = data.funcionariosJaSelecionados;
    }

    if (data) {
      this.mostrarFunil = data.mostrarFunil;
      this.mostrarSomenteDoFunil = data.mostrarSomenteDoFunil;
    }
  }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarFuncionarios();
  }

  buscarFunis() {
    this.carregandoService.mostra('buscaFunis');

    this.crmService.consultarCRM().subscribe(resp => {
      this.funis = resp;
      this.pesquisarFuncionarios();
      this.carregandoService.esconde('buscaFunis');
    }, (erro) => {
      this.carregandoService.esconde('buscaFunis');
      this.notificacaoService.erro(erro);
    });
  }

  selecionarTodosCheckBox() {
    this.funcionariosFiltrados.forEach(p => {
      if (!p.bloquearCheck) {
        p.checado = this.selecaoTodos;
      }
    });
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarFuncionarios();
    this.paginator.firstPage();
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFuncionarios();
  }

  buscarFuncionarios() {
    if (this.mostrarFunil && !this.funis) {
      this.buscarFunis();
    } else {
      this.pesquisarFuncionarios();
    }
  }

  pesquisarFuncionarios() {
    this.carregandoService.mostra('buscaFuncionarios');

    this.funcionarioService.consultarFuncionariosComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', true, this.mostrarSomenteDoFunil, null).subscribe(dados => {

      const total = Number(dados.total);
      this.funcionariosFiltrados = dados.itens;

      if (this.mostrarFunil) {
        this.funcionariosFiltrados.forEach(f => {
          if (!f.funilPadrao && this.funis.length > 0) {
            f.funilPadrao = this.funis[0].id;
          }
        });
      }

      this.funcionariosJaSelecionados.forEach(id => {
        const funcionarioParaBloquear = this.funcionariosFiltrados.find(p => Number(p.idFuncion) === id);

        if (funcionarioParaBloquear) {
          funcionarioParaBloquear.bloquearCheck = true;
        }
      });

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = total;
      this.carregando = false;
      this.carregandoService.esconde('buscaFuncionarios');
    }, (erro) => {
      this.carregandoService.esconde('buscaFuncionarios');
      this.notificacaoService.erro(erro);
    });
  }

  selecionaFuncionario(funcionario) {
    this.dialogRef.close(funcionario);
  }

  retornarChecados() {
    this.dialogRef.close(this.funcionariosFiltrados.filter(p => p.checado));
  }

  algumChecado() {
    return this.funcionariosFiltrados.some(p => p.checado);
  }

  fechar() {
    this.dialogRef.close();
  }

  selecionarTodos() {
    const funcionarioTodos = new Funcionario();
    funcionarioTodos.nome = 'Todos';
    this.dialogRef.close(funcionarioTodos);
  }

  retornaPerfil(perfil) {
    switch (perfil) {
    case 1:
      return 'Ve';

    case 2:
      return 'Ad';

    default:
      break;
    }
  }

  retornaClassePerfil(perfil) {
    switch (perfil) {
    case 1:
      return 'badge-primary';

    case 2:
      return 'badge-info';

    default:
      break;
    }
  }

  ngOnDestroy(): void {}
}